import { apiClient } from './api'

export const legalService = {
  async getCurrentDocuments() {
    const response = await apiClient.get('/legal/documents/current')
    return response.data?.data ?? []
  },

  async getRequired() {
    const response = await apiClient.get('/me/legal/required')
    return response.data?.data ?? []
  },

  async acceptDocument(documentVersionId, source = 'web') {
    const response = await apiClient.post('/me/legal/accept', {
      documentVersionId,
      source,
    })
    return response.data?.data ?? response.data
  },

  async getAcceptances() {
    const response = await apiClient.get('/me/legal/acceptances')
    return response.data?.data ?? []
  },

  async getConsents() {
    const response = await apiClient.get('/me/consents')
    return response.data?.data ?? []
  },

  async grantConsent(consentType, payload = {}) {
    const response = await apiClient.post(`/me/consents/${consentType}/grant`, payload)
    return response.data?.data ?? response.data
  },

  async withdrawConsent(consentType, payload = {}) {
    const response = await apiClient.post(`/me/consents/${consentType}/withdraw`, payload)
    return response.data?.data ?? response.data
  },
}

export default legalService
